import { render, staticRenderFns } from "./detailFormDsitribution.vue?vue&type=template&id=026e5e8d"
import script from "./detailFormDsitribution.vue?vue&type=script&lang=js"
export * from "./detailFormDsitribution.vue?vue&type=script&lang=js"
import style0 from "./detailFormDsitribution.vue?vue&type=style&index=0&id=026e5e8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports